import axios from "axios";

export const get_coupons = () => {
    return axios
        .get(
            "/api/coupons",
            "",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};

export const get_settings = () => {
    return axios
        .get(
            "/api/settings",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};
export const save_settings = (used_free_characters, free_pool_limit) => {
    return axios
        .post(
            "/api/settings",
            {used_free_characters, free_pool_limit},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};

export const addCoupon = (type, value, allowed, code, usages, begin_at, expiration_at, active) => {
    return axios
        .post(
            "/api/coupons",
            {type, value, allowed, code, usages, begin_at, expiration_at, active},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};
export const editCoupon = (id, type, value, allowed, code, usages, begin_at, expiration_at, active) => {
    return axios
        .patch(
            "/api/coupons/" + id,
            {type, value, allowed, code, usages, begin_at, expiration_at, active},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};
export const removeCoupon = (id) => {
    return axios
        .delete(
            "/api/coupons/" + id,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};
